import React, {useContext} from "react";
import { DataContext } from "../../DataContext"; // Import the context
import Slider from "react-slick";
import "./Banner.scss";
// import Button from "../Button/Button";
import BannerImage from "../../images/banner-image-d-1.jpg";
import BannerImageTwo from "../../images/Img.jpg";
import BannerImageThree from "../../images/banner-image-d-3.jpg";
import BannerImageHead from "../../images/kem-cho-ahmedabad.png";

const Banner = () => { 
  const { data } = useContext(DataContext);
  const updatedSubscriptionAmount = data?.updatedSubscriptionAmount || 500;
  const planOriginalValue = data?.planOriginalValue || 500;
  const subDurationValue = data?.subscriptionDuration || 30;
  const subscriptionDepositAmount = data?.subscriptionDepositAmount || 500;

  // Mapping durations to labels
  const durationMapping = {
    1: "Daily",
    3: "Every 3 Days",
    7: "Weekly",
    15: "Bi-Weekly",
    30: "Monthly",
    60: "Every 2 Months",
    90: "Quarterly",
    180: "Half-Yearly",
    365: "Yearly"
  };

  const subDuration = `${durationMapping[subDurationValue]}`;

  const images = [BannerImage, BannerImageTwo, BannerImageThree];

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <section className="banner ">
      <Slider {...settings} className="banner-slider">
        {images.map((image, index) => (
          <div key={index}>
            <div
              className="banner-slide"
              style={{
                backgroundImage: `url(${image})`,
              }}
            />
          </div>
        ))}
      </Slider>
      <div className="container">
        <div className="banner-content">
          <figure>
            <img src={BannerImageHead} alt="" />
          </figure>
          <h1>
            Welcome to hassle free cycling
          </h1>
          {data && 
          <div className="banner-content__section">
              <p>Your all-inclusive bike subscription
              <span>with free repairs and maintenance.</span></p>
              <div className="banner-content__section-pricing">
                <div className="monthly-payment">
                  <span className="old-price">₹{planOriginalValue}</span>
                  <h2>₹{updatedSubscriptionAmount}<span>{subDuration} Rent</span></h2>
                </div>
                <div className="plus">+</div>
                <div className="deposit">
                  <h2>₹{subscriptionDepositAmount}<span>Refundable Deposit</span></h2>
                </div>
              </div>
          </div>}
        </div>
      </div>
    </section>
  );
};

export default Banner;
